import { setup } from './lib/allauth'
import SETTINGS from "../settings";

export function init () {
//  if (document.location.hostname === 'mobileapp')
 //   setup('app', `${SETTINGS.baseAPIUrl}/_allauth/app/v1`, false)
    setup('browser', `${SETTINGS.baseAPIUrl}/_allauth/browser/v1`, true)
}
